import { Link } from "react-router-dom";
import { useListaDeBoletos } from "@/api/consultas";
import { FaixaDeErro } from "@/componentes/FaixaDeErro";
import { Tabela } from "@/componentes/Tabela";
import { idCurto } from "@/formato";
import { rotaDoBoleto, rotaDosBoletos } from "@/rotas";
import { useSessao } from "@/sessao/useSessao";
import { CarregarMais, COLUNAS_ESSENCIAIS, contagemDaLista } from "@/telas/boletos/Boletos";
import { useCedenteDaRota } from "./useCedenteDaRota";

/*
 * `/cedentes/:id/boletos`: a lista só leitura do cedente, pelo filtro `pessoa_id` da API, e
 * sem botão de emitir (doc 06 §6). O filtro é fixo, e por isso não vira pílula.
 *
 * A linha abre o painel na tela de Boletos, com o cedente na consulta: fechar cai na lista
 * dele, e não em todos os boletos. O link leva à mesma lista para filtrar e exportar.
 */
export function AbaDeBoletos() {
  const { id } = useCedenteDaRota();
  const { cliente, estado } = useSessao();
  const lista = useListaDeBoletos(cliente, { pessoa_id: id }, estado.fase === "dentro");

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap items-center gap-3">
        {!lista.carregando && lista.erro === null && (
          <span className="rotulo">{contagemDaLista(lista)}</span>
        )}
        <Link
          to={rotaDosBoletos({ pessoa_id: id })}
          className="ml-auto text-esferografica underline-offset-2 hover:underline"
        >
          Abrir em Boletos
        </Link>
      </div>

      {lista.erro !== null ? (
        <FaixaDeErro erro={lista.erro} />
      ) : (
        <>
          <Tabela
            rotulo="Boletos do cedente"
            colunas={COLUNAS_ESSENCIAIS}
            itens={lista.itens}
            carregando={lista.carregando}
            chaveDe={(boleto) => boleto.id}
            hrefDe={(boleto) => rotaDoBoleto(boleto.id, `?pessoa_id=${id}`)}
            rotuloDe={(boleto) => `Boleto ${boleto.referencia_externa ?? idCurto(boleto.id)}`}
            vazio="Nenhum boleto."
          />
          <CarregarMais lista={lista} />
        </>
      )}
    </div>
  );
}
